module.exports = __webpack_public_path__ + "static/img/phone.590f58ba.svg";